import React from 'react';
import { Box } from '@mantine/core';

import CompaniesTab from './companies/CompaniesTab';
import UnprocessedValuationUpdatesTab from 'src/secret-menu/bulk-valuations/UnprocessedValuationUpdatesTab';
import { Navigate, useParams } from 'react-router-dom';
import TemplatesListPage from 'src/company/templates/components/TemplatesListPage';
import PageWithSidebar from 'src/UI/page-nav/PageWithSidebar';
import DeprecatedTemplateTab from 'src/secret-menu/templates/DeprecatedTemplateTab';
import FeatureFlagsTab from 'src/secret-menu/feature-flags/FeatureFlagsTab';
import CompanyUsersPage from 'src/secret-menu/company-users/CompanyUsersPage';
import EditorPlaygroundTab from './editor-playground/EditorPlaygroundTab';
import CompanyClientsPage from 'src/secret-menu/company-clients/CompanyClientsPage';

const SecretMenuTabs = {
  companies: 'companies',
  companyUsers: 'company-users',
  companyClients: 'company-clients',
  templates: 'templates',
  oldTemplates: 'old-templates',
  bulkValuations: 'bulk-valuations',
  featureFlags: 'feature-flags',
  editorPlayground: 'editor-playground',
  inlineEdit: 'inline-edit',
} as const;

export default function SecretMenuPage() {
  const { tab } = useParams<{ tab: string }>();

  const SECRET_MENU_LINKS = [
    {
      label: 'Companies',
      href: '/secret-menu/companies',
    },
    {
      label: 'Company users',
      href: '/secret-menu/company-users',
    },
    {
      label: 'Company clients',
      href: '/secret-menu/company-clients',
    },
    {
      label: 'Templates',
      href: '/secret-menu/templates',
    },
    {
      label: 'Templates (old)',
      href: '/secret-menu/old-templates',
    },
    {
      label: 'Bulk valuations',
      href: '/secret-menu/bulk-valuations',
    },
    {
      label: 'Feature flags',
      href: '/secret-menu/feature-flags',
    },
    {
      label: 'Editor playground',
      href: '/secret-menu/editor-playground',
    },
  ];

  if (!tab) {
    return <Navigate to="/secret-menu/companies" replace />;
  }

  const renderContent = () => {
    switch (tab) {
      case SecretMenuTabs.companies:
        return <CompaniesTab />;
      case SecretMenuTabs.companyUsers:
        return <CompanyUsersPage />;
      case SecretMenuTabs.companyClients:
        return <CompanyClientsPage />;
      case SecretMenuTabs.templates:
        return <TemplatesListPage />;
      case SecretMenuTabs.oldTemplates:
        return <DeprecatedTemplateTab />;
      case SecretMenuTabs.bulkValuations:
        return <UnprocessedValuationUpdatesTab />;
      case SecretMenuTabs.featureFlags:
        return <FeatureFlagsTab />;
      case SecretMenuTabs.editorPlayground:
        return <EditorPlaygroundTab />;
      default:
        return <Navigate to="/secret-menu/companies" replace />;
    }
  };

  return (
    <Box component="pre">
      <PageWithSidebar links={SECRET_MENU_LINKS} activeUrl={`/company/${tab}`}>
        {renderContent()}
      </PageWithSidebar>
    </Box>
  );
}
